/*
 * @Author: liguokang
 * @Date: 2021-07-18 14:00:26
 * @LastEditors: liguokang
 * @LastEditTime: 2021-07-22 16:28:36
 * @Description:
 * @Copyrigh: ©2021 杭州杰竞科技有限公司 版权所有
 */
// 重定义YDUI覆盖的VANTUI dialog
import confirm from 'vant/lib/dialog';
let Confirms = confirm.confirm;
export { Confirms };



// WEBPACK FOOTER //
// ./src/components/globleComponents/Confirm/index.js